import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AnalysisState {
  // Current period being analyzed
  currentPeriod: string | null;
  // Selected report ID
  selectedReportId: string | null;
  // Current view: list, details, or generate
  currentView: 'list' | 'details' | 'generate';
  // Expanded accordion items
  expandedAccordions: string[];
  // Saved scroll position
  savedScrollPosition: number;
  // Current task ID (for generate view)
  currentTaskId: string | null;
}

const initialState: AnalysisState = {
  currentPeriod: null,
  selectedReportId: null,
  currentView: 'details',
  expandedAccordions: [],
  savedScrollPosition: 0,
  currentTaskId: null,
};

const analysisSlice = createSlice({
  name: 'analysis',
  initialState,
  reducers: {
    setCurrentPeriod: (state, action: PayloadAction<string | null>) => {
      // When period changes, clear task ID to avoid showing stale tasks
      if (state.currentPeriod !== action.payload) {
        state.currentTaskId = null;
        state.selectedReportId = null;
      }
      state.currentPeriod = action.payload;
    },
    setSelectedReportId: (state, action: PayloadAction<string | null>) => {
      state.selectedReportId = action.payload;
    },
    setCurrentView: (state, action: PayloadAction<'list' | 'details' | 'generate'>) => {
      state.currentView = action.payload;
    },
    setExpandedAccordions: (state, action: PayloadAction<string[]>) => {
      state.expandedAccordions = action.payload;
    },
    setSavedScrollPosition: (state, action: PayloadAction<number>) => {
      state.savedScrollPosition = action.payload;
    },
    setCurrentTaskId: (state, action: PayloadAction<string | null>) => {
      state.currentTaskId = action.payload;
    },
    // Reset all state (useful when closing the analysis sheet)
    resetAnalysisState: (state) => {
      state.currentView = 'details';
      state.expandedAccordions = [];
      state.savedScrollPosition = 0;
      // Keep period, report, and task for continuity
    },
  },
});

export const {
  setCurrentPeriod,
  setSelectedReportId,
  setCurrentView,
  setExpandedAccordions,
  setSavedScrollPosition,
  setCurrentTaskId,
  resetAnalysisState,
} = analysisSlice.actions;

export default analysisSlice.reducer;
